<script lang="ts">
  import { createQuery } from '@tanstack/svelte-query';
  import { versionApi } from '$lib/api/version';
  import { t } from '$lib/i18n';

  const versionQuery = createQuery(() => ({
    queryKey: ['version'],
    queryFn: () => versionApi.get()
  }));
</script>

<footer class="px-6 py-3 text-center text-[11px] text-dark-gray">
  {t('footer.text', { version: versionQuery.data?.version ?? '...' })}
</footer>
